/**
 * Container branch children, both directions.
 *
 * If/Switch hold other components. Both directions have to go through the
 * child's own transform, or nesting breaks:
 *
 *   - Import used to wrap each branch child as `{ type, properties: rawJson }`,
 *     one level deep only. A nested container's children then stayed raw Flow
 *     JSON, so the next export called `transformToWhatsApp(undefined)` on them
 *     and threw. Conditional routing with two or more rules produces exactly
 *     that shape (buildIfTree nests an If per rule), so reloading such a flow
 *     and saving it crashed.
 *
 *   - It also meant nested children carried WhatsApp-shaped props while
 *     top-level children carried builder-shaped ones, the same component
 *     validated and rendered differently depending on its depth.
 *
 * Recursion is implicit: a container's own transform calls back into these.
 */

import { flowComponentRegistry } from './FlowComponentRegistry';
import { generateId } from './idGeneration';

/** WhatsApp JSON child -> builder `{ id, type, properties }`. */
export const toBuilderChild = (sub) => {
  const component = flowComponentRegistry.get(sub.type);
  return {
    id: generateId(),
    type: sub.type,
    properties: component ? component.transformFromWhatsApp(sub) : { ...sub },
  };
};

/** Builder child -> WhatsApp JSON. */
export const toWhatsAppChild = (sub) => {
  const component = flowComponentRegistry.get(sub.type);
  return component
    ? component.transformToWhatsApp(sub.properties)
    : { type: sub.type, ...sub.properties };
};
